import { Body, Controller, Post, Req, UseInterceptors } from "@nestjs/common";
import { ApiBody, ApiTags } from "@nestjs/swagger";
import {
  CommonResponseModel,
  Divisionreq,
} from "@project-management-system/shared-models";
import { ApplicationExceptionHandler } from "packages/libs/backend-utils/src/";
import { DivisionService } from "./division-service";


@ApiTags("/division")
@Controller("division")
export class DivisionController {
  constructor(
    private readonly divisionService: DivisionService,
    private readonly applicationExceptionHandler: ApplicationExceptionHandler
  ) { }

  @Post("/createDivision")
  async createDivision(@Body() dto: any): Promise<CommonResponseModel> {
    try {
      return await this.divisionService.createDivision(dto, false);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(
        CommonResponseModel,
        error
      );
    }
  }

  @Post("/updateDivision")
  async updateDivision(@Body() req: any): Promise<CommonResponseModel> {
    try {
      return await this.divisionService.createDivision(req,true);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(
        CommonResponseModel,
        error
      );
    }
  }

  @Post("/getAllDivision")
  async getAllDivision(): Promise<CommonResponseModel> {
    try {
      return await this.divisionService.getAllDivision();
    } catch (err) {
      return this.applicationExceptionHandler.returnException(
        CommonResponseModel,
        err
      );
    }
  }

  @Post('/getAllActiveDivision')
    async getAllActiveDivision(): Promise<CommonResponseModel> {
        try {
            return await this.divisionService.getAllActiveDivision();
        } catch (error) {
            // return errorHandler(ProcurmentGroupResponseModel,error);
            return this.applicationExceptionHandler.returnException(CommonResponseModel, error);
        }
    }

  @Post("/activateOrDeactivateDivision")
  async activateOrDeactivateDivision(@Body() dto: any ): Promise<CommonResponseModel> {
    try {
      return await this.divisionService.activateOrDeactivateDivision(dto);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(
        CommonResponseModel,
        error
      );
    }
  }
}
